import { Component } from '@angular/core';

import { HeaderBannerComponent } from '../../../shared/components/header-banner/header-banner.component';
import { StartPlaningMobileComponent } from '../../../shared/components/start-planing-mobile/start-planing-mobile.component';

@Component({
  selector: 'app-accessibility-declaration',
  imports: [HeaderBannerComponent, StartPlaningMobileComponent],
  templateUrl: './accessibility-declaration.component.html',
  styleUrl: './accessibility-declaration.component.scss',
})
export class AccessibilityDeclarationComponent {}
